import { useQuery } from '@tanstack/react-query';
import { format, startOfMonth } from 'date-fns';
import { supabase } from '@/integrations/supabase/client';
import { mapaFatoresExcecao } from '../../../../backend/src/domain/comissao/excecaoMesAnterior';

/**
 * Quem validou o mês pela chance do mês seguinte (Douglas 03/11/2026, Regras do
 * sistema): usuário → fator (0,5). A prova mora no banco
 * (`fn_regra_excecao_fatores`), a mesma que a folha lê.
 */
export function useFatoresExcecao(competencia: Date) {
  const comp = format(startOfMonth(competencia), 'yyyy-MM-01');
  return useQuery({
    queryKey: ['regras-excecao-fatores', comp],
    staleTime: 60_000,
    queryFn: async (): Promise<Map<string, number>> => {
      const { data, error } = await supabase.rpc('fn_regra_excecao_fatores', { p_competencia: comp });
      if (error) throw error;
      return mapaFatoresExcecao(data);
    },
  });
}
